import { render } from "./historialMain.vue?vue&type=template&id=05c7dd3c&scoped=true"
import script from "./historialMain.vue?vue&type=script&lang=js"
export * from "./historialMain.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-05c7dd3c"

export default script